import {getPublicProperty} from '@netx/core-app-next/utils/getPublicProperty';
import {AuthPref} from '../constants';

export const canSelfRegister = () => {
	return getPublicProperty(AuthPref.SELF_REGISTRATION, true);
};

export default canSelfRegister;
